import { ROUTES } from 'common/constants';

import {
  CommercializationItemKeys,
  FeatureItemKeys,
  FinancialItemKeys,
  OrdersAndPaymentsItemKeys,
  ResourcesItemKeys,
  RevisionItemKeys,
} from './menu-item/feature-list.data';

const PathnameToFeatureKey = {
  [ROUTES.PURCHASE]: OrdersAndPaymentsItemKeys.PURCHASE,
  [ROUTES.BALANCE_AI_LIST]: RevisionItemKeys.BALANCE_AI,
  [ROUTES.NO_COST_RECORDS]: RevisionItemKeys.NO_COST_RECORDS,
  [ROUTES.INVOICE]: OrdersAndPaymentsItemKeys.INVOICE,
  [ROUTES.ACCOUNTS_PAYABLE]: OrdersAndPaymentsItemKeys.ACCOUNTS_PAYABLE,
  [ROUTES.STOCK]: FeatureItemKeys.STOCK,
  [`${ROUTES.STOCK}/${ROUTES.MOVEMENTS_STOCK}`]: FeatureItemKeys.STOCK,
  [ROUTES.REPORT_GENERAL_LEDGER]: FeatureItemKeys.REPORT_GENERAL_LEDGER,
  [ROUTES.MATERIAL_CONSUMPTION]: FeatureItemKeys.MATERIAL_CONSUMPTION,
  [ROUTES.FINANCIAL]: FinancialItemKeys.OVERVIEW,
  [ROUTES.FINANCIAL_BUDGET]: FinancialItemKeys.BUDGET,
  [ROUTES.FINANCIAL_PRODUCTION]: FinancialItemKeys.PRODUCTION,
  [ROUTES.FINANCIAL_MACHINERY]: FinancialItemKeys.FINANCIAL_MACHINERY,
  [ROUTES.HELP_CENTER]: FeatureItemKeys.HELP_CENTER,
  [ROUTES.ITEM]: ResourcesItemKeys.ITEM,
  [ROUTES.MACHINERY]: ResourcesItemKeys.MACHINERY,
  [ROUTES.ITEM_CATEGORY]: ResourcesItemKeys.ITEM_CATEGORY,
  [ROUTES.SUPPLIER]: ResourcesItemKeys.SUPPLIER,
  [ROUTES.DASHBOARD]: FeatureItemKeys.DASHBOARD,
  [ROUTES.ELECTRONIC_INVOICE]: OrdersAndPaymentsItemKeys.ELECTRONIC_INVOICE,
  [ROUTES.AG_OPERATION]: FeatureItemKeys.AG_OPERATION,
  [ROUTES.BANK_ACCOUNT]: ResourcesItemKeys.BANK_ACCOUNT,
  [ROUTES.REPORTS]: FeatureItemKeys.REPORTS,
  [ROUTES.COMMERCIALIZATION]: CommercializationItemKeys.CONTRACTS,
  [ROUTES.COMMERCIALIZATION_STOCK]: CommercializationItemKeys.STOCK,
  [ROUTES.COMMERCIALIZATION_MOVEMENTS]: CommercializationItemKeys.MOVEMENTS,
};

const getFeatureKeyFromPathname = (
  pathname: string,
):
  | FeatureItemKeys
  | CommercializationItemKeys
  | ResourcesItemKeys
  | FinancialItemKeys
  | OrdersAndPaymentsItemKeys
  | RevisionItemKeys
  | undefined => {
  return PathnameToFeatureKey[pathname as keyof typeof PathnameToFeatureKey];
};

export { getFeatureKeyFromPathname };
